import {
  GET_FFAGENT_ADDRESSES_REQ,
  GET_FFAGENT_ADDRESSES_SUCCESS,
  GET_FFAGENT_ADDRESSES_FAIL,
  GET_FFAGENT_ADDRESS_REQ,
  GET_FFAGENT_ADDRESS_SUCCESS,
  GET_FFAGENT_ADDRESS_FAIL,
  UPDATE_FFAGENT_ADDRESS_REQ,
  UPDATE_FFAGENT_ADDRESS_SUCCESS,
  UPDATE_FFAGENT_ADDRESS_FAIL,
  DELETE_FFAGENT_ADDRESS_REQ,
  DELETE_FFAGENT_ADDRESS_SUCCESS,
  DELETE_FFAGENT_ADDRESS_FAIL,
  CREATE_FFAGENT_ADDRESS_REQ,
  CREATE_FFAGENT_ADDRESS_SUCCESS,
  CREATE_FFAGENT_ADDRESS_FAIL,
  GET_FFAGENT_ADDRESS2_REQ,
  GET_FFAGENT_ADDRESS2_SUCCESS,
  GET_FFAGENT_ADDRESS2_FAIL,
  SET_FFAGENT_ADDRESS_DATA,
  SET_FFAGENT_ADDRESS_DATA1,
  SET_FFAGENT_ADDRESS_DATA2,
} from '../constants';

const INIT_STATE = {
  addresses: [],
  loading: false,
  addressData: {},
  addressData2: {},
};

const ffAgentAddressReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FFAGENT_ADDRESSES_REQ:
    case GET_FFAGENT_ADDRESS_REQ:
    case GET_FFAGENT_ADDRESS2_REQ:
      return {
        ...state,
        loading: true,
      };
    case GET_FFAGENT_ADDRESSES_SUCCESS:
      return {
        ...state,
        loading: false,
        addresses: action.payload,
      };

    case GET_FFAGENT_ADDRESS2_SUCCESS:
      return {
        ...state,
        addressData2: action.payload,
      };

    case GET_FFAGENT_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        addressData: action.payload,
      };
    case GET_FFAGENT_ADDRESSES_FAIL:
    case GET_FFAGENT_ADDRESS_FAIL:
      return {
        ...state,
        loading: false,
      };

    case CREATE_FFAGENT_ADDRESS_REQ:
    case UPDATE_FFAGENT_ADDRESS_REQ:
    case DELETE_FFAGENT_ADDRESS_REQ:
      return {
        ...state,
        loading: true,
      };
    case CREATE_FFAGENT_ADDRESS_SUCCESS:
    case UPDATE_FFAGENT_ADDRESS_SUCCESS:
    case DELETE_FFAGENT_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CREATE_FFAGENT_ADDRESS_FAIL:
    case UPDATE_FFAGENT_ADDRESS_FAIL:
    case DELETE_FFAGENT_ADDRESS_FAIL:
    case GET_FFAGENT_ADDRESS2_FAIL:
      return {
        ...state,
        loading: false,
      };
    case SET_FFAGENT_ADDRESS_DATA:
      return {
        ...state,
        addressData: {},
        addressData2: {},
      };

    case SET_FFAGENT_ADDRESS_DATA1:
      return {
        ...state,
        addressData: {},
      };

    case SET_FFAGENT_ADDRESS_DATA2:
      return {
        ...state,
        addressData2: {},
      };

    default:
      return state;
  }
};
export default ffAgentAddressReducer;
